export enum TicketStatusEnum {
  New = 'New',
  Open = 'Open',
  Closed = 'Closed',
}
